import * as types from './mutation-types'
export default {
  [types.UPDATE_FENCE_DATAS] (state, payload) {
    let aData = payload.data
    if (Array.isArray(aData)) {
      if (payload.typeId == 1) {
        // 点
        state.markerDatas = [...aData]
      } else if (payload.typeId == 2) {
        // 区域
        state.areaDatas = [...aData]
      }
    } else {
      state.markerDatas = []
      state.areaDatas = []
    }
  },
  [types.UPDATE_LINE_DATAS] (state, payload) {
    let aData = payload.data
    if (Array.isArray(aData)) {
      state.lineDatas = [...aData]
    } else {
      state.lineDatas = []
    }
  },
  [types.UPDATE_SMART_DATAS] (state, payload) {
    let aData = payload.data
    if (Array.isArray(aData)) {
      state.smartDatas = [...aData]
    } else {
      state.smartDatas = []
    }
  },
  [types.UPDATE_STANDARD_TRACK_DATA] (state, payload) {
    if (Array.isArray(payload)) {
      state.standardTrackData = payload
    } else {
      state.standardTrackData = []
    }
  },
  [types.CATEGORY_LIST] (state, payload) {
    state.categoryList = payload.data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js